<script setup lang="ts">
  import type { ContentImageProps } from './types'

  withDefaults(defineProps<ContentImageProps>(), {
    alt: '',
    roundedClass: '',
    showPlayButton: false,
    darkenOnHover: false,
  })
</script>

<template>
  <div class="relative h-full w-full overflow-hidden" :class="roundedClass">
    <img
      :src="src"
      :alt="alt"
      class="h-full w-full object-cover transition-all duration-300"
      :class="{
        'group-hover:brightness-[0.8] hover:brightness-[0.8]': darkenOnHover,
      }"
      loading="lazy"
    />
    <div
      v-if="showPlayButton"
      class="absolute inset-0 flex items-center justify-center pointer-events-none"
    >
      <div
        class="flex h-10 w-10 items-center justify-center rounded-full bg-overlay-default"
      >
        <svg
          class="ml-0.5 h-5 w-5 text-content-on-overlay"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
    </div>
  </div>
</template>
